import { getSubdomainAndTLD } from '../../utils/general'
import {
  showTrackedLinkCreateModal,
  setShowPaymentModal,
  showUpgradeCardModal,
  UPGRADE_EMBED_PAYLOAD
} from '../../actions'
import { PLANS } from '../../constants/plans'
import { setQrCodeModal, setQrCodeData, setEmbedData } from '../../Manage/actions'
import { UPGRADE_QR_PAYLOAD } from '../../actions'
import { Badge } from 'react-bootstrap'
import OptionsModalOption from './components/OptionsModalOption'
import OptionsModalOptionDropdown from './components/OptionsModalOptionDropdown'

const getShareOptions = ({ url, hasAccess, dispatch, onClose, site, userProfile }) => {
  const urlParams = getSubdomainAndTLD({ site: { subdomain: url } })
  const title = 'Check out this link!'
  const redirect_url = `${urlParams.subdomain}.tiiny.xyz/?d=${urlParams.tld.replace(/^\./, '')}`
  const linkedInURL = `https://www.linkedin.com/sharing/share-offsite/?url=${redirect_url}`
  const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${redirect_url}&quote=${encodeURIComponent(title)}`

  return [
    {
      isVisible: true,
      component: (
        <OptionsModalOption
          icon="/assets/icons/export/tracked.svg"
          title={
            <span>
              Share & Track{' '}
              <Badge bg="secondary" className="ms-2 badge-bg">
                New
              </Badge>
            </span>
          }
          description="Create a unique link for a specific recipient and track when it’s opened"
          onClick={() => {
            if (!hasAccess) {
              dispatch(
                showUpgradeCardModal({
                  title: 'Create tracked links',
                  gif: '/assets/img/gifs/tracked-links.gif',
                  desc: 'Generate a unique link for each recipient, track opens and clicks, and know exactly when your content is viewed.',
                  cta: 'Create tracked link',
                  onClick: () =>
                    dispatch(
                      setShowPaymentModal({
                        showPaymentModal: true,
                        upgradePlanId: PLANS.PRO.id
                      })
                    )
                })
              )
            } else {
              dispatch(showTrackedLinkCreateModal({ site }))
              onClose()
            }
          }}
        />
      )
    },
    {
      isVisible: true,
      component: (
        <OptionsModalOption
          icon="/assets/icons/export/qr.svg"
          title="QR Code"
          description="Get a QR code to put anywhere online & offline"
          onClick={() => {
            if (!userProfile.productId) {
              dispatch(
                showUpgradeCardModal({
                  ...UPGRADE_QR_PAYLOAD,
                  onClick: () =>
                    dispatch(
                      setShowPaymentModal({
                        showPaymentModal: true,
                        upgradePlanId: PLANS.TINY.id
                      })
                    )
                })
              )
            } else {
              dispatch(setQrCodeModal(true))
              dispatch(setQrCodeData(site))
              onClose()
            }
          }}
        />
      )
    },
    {
      isVisible: true,
      component: (
        <OptionsModalOption
          icon="/assets/icons/export/embed.svg"
          title="Embed"
          description="Embed your project’s code on another website"
          onClick={() => {
            if (!userProfile.productId) {
              dispatch(
                showUpgradeCardModal({
                  ...UPGRADE_EMBED_PAYLOAD,
                  onClick: () =>
                    dispatch(
                      setShowPaymentModal({
                        showPaymentModal: true,
                        upgradePlanId: PLANS.TINY.id
                      })
                    )
                })
              )
            } else {
              dispatch(setEmbedData(true, site))
              onClose()
            }
          }}
        />
      )
    },
    {
      isVisible: true,
      component: (
        <OptionsModalOptionDropdown
          icon="/assets/icons/export/share.svg"
          title="Social Sharing"
          description="For sharing on social media, and other public platforms"
          items={[
            {
              icon: '/assets/icons/facebook.svg',
              label: 'Facebook',
              href: facebookURL
            },
            {
              icon: '/assets/icons/linkedin.svg',
              label: 'LinkedIn',
              href: linkedInURL
            }
          ]}
        />
      )
    }
  ]
}

export default getShareOptions
